var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIvoryCoast(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5003:52962)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.9999 32.874C17.957 32.874 19.8318 32.522 21.5651 31.8788L22.2607 16.874L21.5651 1.86921C19.8318 1.22609 17.957 0.874023 15.9999 0.874023C14.0428 0.874023 12.1679 1.22609 10.4347 1.86921L9.73901 16.874L10.4346 31.8788C12.1679 32.522 14.0428 32.874 15.9999 32.874Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0 16.8742C0 23.7536 4.342 29.6183 10.4348 31.879V1.86935C4.342 4.13004 0 9.99473 0 16.8742Z",
    fill: "#FF9811"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.5652 1.86935V31.879C27.658 29.6183 32 23.7536 32 16.8742C32 9.99473 27.658 4.13004 21.5652 1.86935V1.86935Z",
    fill: "#6DA544"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5003:52962"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.874023)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIvoryCoast);
export default __webpack_public_path__ + "static/media/ivory-coast.d76631b3.svg";
export { ForwardRef as ReactComponent };